<template>
  <component @show-enlarged="showEnlarged" :is="`${node.id}-widget`" :widget="node.data" />
</template>

<script>
  import LayerWidget from '@/components/templates/designer/widgets/LayerWidget.vue';
  import TextWidget from '@/components/templates/designer/widgets/TextWidget.vue';
  import ClockWidget from '@/components/templates/designer/widgets/ClockWidget.vue';
  import ButtonWidget from '@/components/templates/designer/widgets/ButtonWidget.vue';
  import ImageWidget from '@/components/templates/designer/widgets/ImageWidget.vue';
  import AppWidget from '@/components/templates/designer/widgets/AppWidget.vue';
  import VideoWidget from '@/components/templates/designer/widgets/VideoWidget.vue';
  import PdfWidget from '@/components/templates/designer/widgets/PdfWidget.vue';
  import AudioWidget from '@/components/templates/designer/widgets/AudioWidget.vue';
  import TenantWidget from '@/components/templates/designer/widgets/TenantsWidget.vue';
  import RichtextWidget from '@/components/templates/designer/widgets/RichTextWidget.vue';
  import TrafiklabWidget from '@/components/templates/designer/widgets/TrafiklabWidget.vue';
  import WeatherWidget from '@/components/templates/designer/widgets/WeatherWidget.vue';
  import RssWidget from '@/components/templates/designer/widgets/RssWidget.vue';
  import LinkWidget from '@/components/templates/designer/widgets/LinkWidget.vue';
  import TableWidget from '@/components/templates/designer/widgets/TableWidget.vue';
  import TimeWidget from '@/components/templates/designer/widgets/TimeWidget.vue';
  import DateWidget from '@/components/templates/designer/widgets/DateWidget.vue';

  export default {
    name: 'WidgetNode',

    props: {
      node: {
        type: Object,
        default: () => {},
      },
    },

    methods: {
      showEnlarged(w) {
        this.$emit('show-enlarged', w);
      },
    },

    components: {
      AudioWidget,
      ImageWidget,
      LayerWidget,
      TextWidget,
      ClockWidget,
      ButtonWidget,
      AppWidget,
      VideoWidget,
      PdfWidget,
      TenantWidget,
      RichtextWidget,
      WeatherV2Widget: WeatherWidget,
      TrafiklabV2Widget: TrafiklabWidget,
      RssV2Widget: RssWidget,
      LinkWidget,
      TableV2Widget: TableWidget,
      TimeWidget,
      DateWidget,
    },
  };
</script>

<style scoped></style>
